<template>
  <ContextMenu :id="id" :items="menu" align="right" />
</template>

<script>
import ContextMenuMixin from "mixins/ContextMenu";

export default {
  mixins: [ContextMenuMixin],

  props: {
    section: { type: String, default: "training" },
  },

  computed: {
    routeParam() {
      return { company: this.item.id };
    },
    menu() {
      let menu = [
        {
          label: "View Details",
          action: () => {
            this.showDetailsPane();
          },
        },
        {
          label: "View Hours",
          action: () => {
            this.showHoursModal();
          },
        },
        {
          label: "View Training",
          action: () => {
            this.goToRoute(`${this.section}.companies.history.index`, {
              company: this.item.id,
              type: "online",
            });
          },
        },
      ];
      if (!!this.item.can_update && this.section === "admin") {
        menu.push({
          label: "Edit",
          action: () => {
            this.goToRoute("admin.companies.edit", this.routeParam);
          },
        });
      }
      if (!!this.item.can_delete && this.section === "admin") {
        menu.push({
          label: "Remove",
          action: () => {
            this.delete();
          },
        });
      }
      menu.sort(this.sortMenu);
      return menu;
    },
  },

  methods: {
    showHoursModal() {
      this.$modal("HoursModal", { company: this.item })
        .then(() => {})
        .catch(() => {});
    },
    delete() {
      var confirmMessage = `Are you sure you would like to remove: "${this.item.name}"?`;
      if (confirm(confirmMessage)) {
        this.axios
          .delete(this.route("admin.companies.destroy", this.routeParam))
          .then(() => {
            var message = `"${this.item.name}" has been removed`;
            this.eventBus.$emit("show-alert", "danger", message, true);
            this.eventBus.$emit("refresh");
          });
      }
    },
  },
};
</script>